import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
} from "@mui/material";
import React from "react";
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { GridSelectionModel } from '@mui/x-data-grid';
import { createTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import axios from "axios";
import { useForm, SubmitHandler } from "react-hook-form";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import EmailIcon from '@mui/icons-material/Email';
import Link from '@mui/material/Link';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { styled } from '@mui/material/styles';
import { setPageTitle } from "../../slices/applicationSlice";
import { IApplication } from "../../interfaces/IApplication";
import { useAppDispatch } from "../../hooks";
import { IFeeding } from "../../interfaces/Growing/IFeeding";
import { ICrew } from "../../interfaces/ICrew";
import { ITray } from "../../interfaces/ITray";
import { MemoizedSelection } from "./GreenhouseTraySelection";
import DailyTasksSelection from "./DailyTasksSelection";
import FeedingDialog from "../../components/Growing/FeedingDialog";
import WeatherDialog from "../../components/Growing/WeatherDialog";
import HouseIcon from '@mui/icons-material/OtherHouses';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ActionButton from "../../components/ActionButton";
import ActionMenu from "../../components/ActionMenu";

const handleSubmitD = () => console.log('Okay')

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

type Anchor = 'top' | 'left' | 'bottom' | 'right';

interface IFormInput {
  Name: string
  Type: string
  Crew: string
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}


function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function DailyTasks() {

    function FeedingClicked(_event: React.MouseEvent<HTMLElement>): void {
      
      setAssignOpen(true);
    }
  
    function WeatherClicked(_event: React.MouseEvent<HTMLElement>): void {
      
      setWeatherOpen(true);
    }

    const [open, setOpen] = useState(false);
    const [assignOpen,setAssignOpen ] = useState(false);
    const [weatherOpen, setWeatherOpen] = React.useState(false);
  
    function handleClose() {
      setOpen(!open);
    }
  
    const buttons = [
      <ActionButton action={FeedingClicked} buttonLabel="ASSIGN FEEDING" />,
      <ActionButton action={WeatherClicked} buttonLabel="ADD WEATHER LOG" />,
      
    ];

  const dispatch = useAppDispatch();

  useEffect(() => {
    let appState: IApplication = {
      pageTitle: "Daily Tasks",
      backgroundPath: "/assets/images/growing.jpg"
    }
    dispatch(setPageTitle(appState));
  }, []);

  const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([]);
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const [rows, setRows] = useState<IPatchingRow[]>([]);

  useEffect(() => {
    axios
      .get('https://localhost:44324/api/PatchingLists')
      .then(res => {
        setRows(res.data);
      })
  }, []);



  const { register, handleSubmit, control, formState: { errors } } = useForm<IFeeding>();

  const onSubmit: SubmitHandler<IFeeding> = data => {
    axios.post('https://localhost:44324/api/Feedings', {
      data
    }).then((data) => {
      if (data.status === 200) {
        setOpen(false);
      };
    });
  };

  
  
  const [helpOpen, setHelpOpen] = React.useState(false);
  const [addOpen, setAddOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickHelpOpen = () => {
    setHelpOpen(true);
  };

  const handleHelpClose = () => {
    setHelpOpen(false);
  };

  const handleWeatherOpen = () => {
    setWeatherOpen(true);
  };

  const handleWeatherClose = () => {
    setWeatherOpen(false);
  };

  const handleAddOpen = () => {
    setAddOpen(true);
  };

  const handleAddClose = () => {
    setAddOpen(false);
  };

  interface IPatchingRow {
    name: string,
    status: string,
    patchweek: number,
    generation: string
  }

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#010101' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    border: 0,
    borderRadius: 0,
    boxShadow: "none",
  }));

  const darkTheme = createTheme({
    palette: {
      mode: 'dark',
      primary: {
        main: '#89B219',
      },
    },
  });

  const [crews, setCrews] = useState<ICrew[]>([]);
  const [selectedTrays, setSelectedTrays] = useState<ITray[]>([]);

  return (
    <div>
      <ActionMenu buttons={buttons} />
      <Grid container spacing={0} bgcolor="#FFF" height='100%' >
        <Grid item xs={12} >
          <Box sx={{ width: '100%', padding: '0' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" >
                <Tab label="Greenhouse" {...a11yProps(0)} icon={<HouseIcon />} iconPosition="start" sx={{ fontSize: '1.5em', fontWeight: '700', letterSpacing: '0' }}/>
                <Tab label="Selection" {...a11yProps(1)} icon={<CheckBoxIcon />} iconPosition="start" sx={{ fontSize: '1.5em', fontWeight: '700', letterSpacing: '0' }} />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}  >
                <Item sx={{ padding: "0px" }}>
                  <div style={{ height: 'calc(100vh - 110px)', width: '100%' }}>
                    <MemoizedSelection setSelectionModel={setSelectionModel} showActionMenu={false} setSelectedTrays={setSelectedTrays} setTitle={false}></MemoizedSelection>
                  </div>
               </Item>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <Grid item xs={12}>
                <Item sx={{ padding: "0px" }}>
                  <div style={{ height: 'calc(100vh - 110px)', width: '100%', padding: '0px' }}>
                    <DailyTasksSelection></DailyTasksSelection>
                  </div>
                </Item>
              </Grid>
            </TabPanel>
          </Box>
        </Grid>
      </Grid>
        <div>
          <BootstrapDialog
            onClose={handleHelpClose}
            aria-labelledby="customized-dialog-title"
            open={helpOpen}
          >
            <BootstrapDialogTitle id="customized-dialog-title" onClose={handleHelpClose}>
              Need Support?
            </BootstrapDialogTitle>
            <DialogContent dividers>
              <Typography sx={{ mb: 3 }} variant="body2" gutterBottom>
                If you are having issues or have questions, please contact us below.
              </Typography>
              <Button size='large' fullWidth variant="contained" startIcon={<SmartphoneIcon />} sx={{ mb: 1, bgcolor: '#89B219' }}>
                <Link href="tel:8003141797" underline="none" color="#FFF"><Typography variant='h6' fontWeight={700}>800-314-1797</Typography></Link>
              </Button>
              <Button size='large' fullWidth variant="contained" startIcon={<EmailIcon />} sx={{ mb: 1, bgcolor: '#89B219' }}>
                <Link href="mailto:bobsmarket@idatp.com" underline="none">
                  <Typography variant='h6' fontWeight={700} color="#FFF">support@idatp.com</Typography></Link>
              </Button>
            </DialogContent>
          </BootstrapDialog>
        </div>
      
      <FeedingDialog open={assignOpen} handleClose={handleClose}></FeedingDialog>

      <WeatherDialog open={weatherOpen} handleClose={handleWeatherClose}></WeatherDialog>

    </div>


  );
}

const patchingWeeks = [
  { label: 'Week One', type: 'week_one' },
  { label: 'Week Two', type: 'week_two' },
  { label: 'Week Three', type: 'week_three' },
  { label: 'Week Four', type: 'week_four' },
];

interface IPatchingListType {
  label: string;
  type: string;
}

const patchingListTypes = [
  { label: 'Generation 1', value: 'gen_one' },
  { label: 'Generation 2', value: 'gen_two' },
  { label: 'Manual', value: 'manual' },
  { label: 'Blow Out', value: 'blow_out' },
];

const marks = [
  {
    value: 0,
    label: 'WK1',
  },
  {
    value: 5,
    label: 'WK2',
  },
  {
    value: 10,
    label: 'WK3',
  },
  {
    value: 15,
    label: 'WK4',
  },
];
